<template>
  <v-card>
    <v-card-title class="orange lighten-5 elevation-0 dark"> <!-- orange lighten-2 -->
      <span class="title grey--text">Channel List</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex>
          <div style="height: 300px; overflow: auto;">
            <v-data-table :headers="headers" :items="channels" hide-actions hide-headers no-data-text="No active channels">
              <template v-slot:items="props">
                <td width="20%">{{ props.item.Channel }}</td>
                <td width="60%">{{ callerID(props.item) }}</td>
                <td class="text-xs-center">{{ props.item.ChannelStateDesc }}</td>
              </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'dash_calls',
  props: {
    channels: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    headers: [
      { text: 'Channel', value: 'Channel', width: '2%' },
      { text: 'Callerid', value: 'CallerIDName' },
      { text: 'State', value: 'ChannelStateDesc', width: '2%', sortable: false, align: 'center' }
    ]
  }),
  methods: {
    callerID: function (channel) {
      if ((channel.CallerIDName === 'Unknown') || (channel.CallerIDName === '<unknown>')) {
        return channel.CallerIDNum
      }
      return channel.CallerIDName
    }
  },
  computed: {
    channelCount: function () {
      return Object.keys(this.channels).length
    }
  }
}
</script>

<style scoped>
.dashtoolbar {
  background: orange;
  /* top: -20px;
  margin-bottom: -20px;
  width: 95%; */
}
</style>
